(function () {
  if (window.EurolinkCromStock && window.EurolinkCromStock.loaded) return;

  var config = window.EurolinkCromStock || {};
  var endpoint = config.endpoint || '/apps/eurolink-stock/check.php';
  var productSelector = '[data-eurolink-stock-check="crom"]';
  var checkoutSelector =
    'button[name="checkout"], input[name="checkout"], .cart__checkout-button, a[href="/checkout"], a[href^="/checkout?"]';

  var states = new WeakMap();
  var cartTimer = null;
  var requestTimeoutMs = 5000;

  window.EurolinkCromStock = Object.assign(config, {
    loaded: true,
    init: init,
    checkCart: checkCart
  });

  installStyles();

  function installStyles() {
    if (document.getElementById('eurolink-crom-stock-style')) return;

    var style = document.createElement('style');
    style.id = 'eurolink-crom-stock-style';
    style.textContent = [
      '.eurolink-stock-status,.eurolink-cart-stock-status{margin:0 0 1rem;font-size:1.3rem;line-height:1.4;color:rgba(var(--color-foreground),.72)}',
      '.eurolink-stock-status--blocked,.eurolink-cart-stock-status{color:rgb(var(--color-foreground))}'
    ].join('');

    (document.head || document.documentElement).appendChild(style);
  }

  function absoluteEndpoint() {
    return new URL(endpoint, window.location.origin);
  }

  function fetchWithTimeout(url, options, timeoutMs) {
    if (!window.AbortController) {
      return fetch(url, options);
    }

    var controller = new AbortController();

    var timer = window.setTimeout(function () {
      controller.abort();
    }, timeoutMs || requestTimeoutMs);

    var fetchOptions = Object.assign({}, options || {}, {
      signal: controller.signal
    });

    return fetch(url, fetchOptions).then(
      function (response) {
        window.clearTimeout(timer);
        return response;
      },
      function (error) {
        window.clearTimeout(timer);
        throw error;
      }
    );
  }

  function isConfirmedBlocked(result) {
    return !!(
      result &&
      result.is_crom === true &&
      result.disable_add_to_cart === true
    );
  }

  function getProductRoot(target) {
    if (!target || !target.closest) return null;
    return target.closest(productSelector);
  }

  function getAddForm(root) {
    if (!root) return null;

    if (root.matches && root.matches('form')) {
      return root;
    }

    return root.querySelector(
      'form[data-type="add-to-cart-form"], form[action*="/cart/add"]'
    );
  }

  function getButtons(root) {
    if (!root) return [];

    return Array.from(
      root.querySelectorAll(
        'button[name="add"], .shopify-payment-button button, .shopify-payment-button__button'
      )
    );
  }

  function getPaymentWrappers(root) {
    if (!root) return [];
    return Array.from(root.querySelectorAll('.shopify-payment-button'));
  }

  function rememberOriginalState(button) {
    if (!button.hasAttribute('data-eurolink-original-disabled')) {
      button.setAttribute(
        'data-eurolink-original-disabled',
        button.disabled ? '1' : '0'
      );
    }
  }

  function restoreButton(button) {
    rememberOriginalState(button);

    var wasDisabled =
      button.getAttribute('data-eurolink-original-disabled') === '1';

    button.disabled = wasDisabled;

    if (wasDisabled) {
      button.setAttribute('aria-disabled', 'true');
    } else {
      button.removeAttribute('aria-disabled');
    }
  }

  function setButtons(root, disabled) {
    getButtons(root).forEach(function (button) {
      rememberOriginalState(button);

      if (disabled) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
      } else {
        restoreButton(button);
      }
    });
  }

  function setPaymentVisible(root, visible) {
    getPaymentWrappers(root).forEach(function (wrapper) {
      if (!wrapper.hasAttribute('data-eurolink-original-display')) {
        wrapper.setAttribute(
          'data-eurolink-original-display',
          wrapper.style.display || ''
        );
      }

      wrapper.style.display = visible
        ? wrapper.getAttribute('data-eurolink-original-display')
        : 'none';
    });
  }

  function statusElement(root) {
    var element = root.querySelector('[data-eurolink-stock-status]');

    if (element) {
      return element;
    }

    element = document.createElement('div');
    element.className = 'eurolink-stock-status';
    element.setAttribute('data-eurolink-stock-status', '');
    element.setAttribute('role', 'status');
    element.hidden = true;

    var buttons = root.querySelector('.product-form__buttons');

    if (buttons && buttons.parentNode) {
      buttons.parentNode.insertBefore(element, buttons);
    } else {
      root.appendChild(element);
    }

    return element;
  }

  function setStatus(root, message, kind) {
    var element = statusElement(root);

    element.textContent = message || '';
    element.hidden = !message;

    element.classList.toggle(
      'eurolink-stock-status--blocked',
      kind === 'blocked'
    );

    element.classList.toggle(
      'eurolink-stock-status--checking',
      kind === 'checking'
    );
  }

  function setState(root, state, result) {
    states.set(root, {
      state: state,
      result: result || null
    });

    if (state === 'checking') {
      setButtons(root, true);
      setPaymentVisible(root, false);
      setStatus(root, 'Provjeravamo dostupnost...', 'checking');
      return;
    }

    if (state === 'blocked') {
      setButtons(root, true);
      setPaymentVisible(root, false);
      setStatus(root, 'Artikal trenutno nije dostupan.', 'blocked');
      return;
    }

    if (state === 'error') {
      // FAIL OPEN:
      // Ako ne možemo potvrditi dostupnost, kupovina je dozvoljena.
      setButtons(root, false);
      setPaymentVisible(root, true);

      setStatus(
        root,
        'Dostupnost trenutno nije moguće potvrditi. Kupovinu možete nastaviti.',
        ''
      );

      return;
    }

    setButtons(root, false);
    setPaymentVisible(root, true);
    setStatus(root, '', '');
  }

  function checkProduct(root, options) {
    options = options || {};

    if (!root) {
      return Promise.resolve({
        ok: false,
        disable_add_to_cart: false,
        verification_failed: true
      });
    }

    var current = states.get(root);

    if (
      !options.force &&
      current &&
      (current.state === 'ok' || current.state === 'error')
    ) {
      return Promise.resolve(current.result);
    }

    if (!options.force && current && current.promise) {
      return current.promise;
    }

    setState(root, 'checking');

    var url = absoluteEndpoint();

    var productId =
      root.getAttribute('data-eurolink-stock-product-id') || '';

    var handle =
      root.getAttribute('data-eurolink-stock-product-handle') || '';

    if (productId) {
      url.searchParams.set('product_id', productId);
    }

    if (handle) {
      url.searchParams.set('handle', handle);
    }

    var promise = fetchWithTimeout(
      url.toString(),
      {
        credentials: 'same-origin',
        cache: 'no-store'
      },
      requestTimeoutMs
    )
      .then(function (response) {
        if (!response.ok) {
          throw new Error('stock_check_http_' + response.status);
        }

        return response.json();
      })

      .then(function (result) {
        // Jedini slučaj gdje blokiramo kupovinu:
        // backend je SIGURNO potvrdio da je Crom proizvod nedostupan.
        if (isConfirmedBlocked(result)) {
          setState(root, 'blocked', result);
        }

        // Potvrđeno dostupan.
        else if (result && result.in_stock === true) {
          setState(root, 'ok', result);
        }

        // Backend kaže da proizvod nije Crom.
        else if (result && result.is_crom === false) {
          setState(root, 'ok', result);
        }

        // Bilo kakav nejasan/nepotpun odgovor:
        // FAIL OPEN.
        else {
          var safeResult = Object.assign({}, result || {}, {
            disable_add_to_cart: false,
            verification_failed: true
          });

          setState(root, 'error', safeResult);
          result = safeResult;
        }

        return result;
      })

      .catch(function (error) {
        // Network error, timeout, 403, 500, invalid JSON itd.
        // FAIL OPEN.
        var result = {
          ok: false,
          disable_add_to_cart: false,
          verification_failed: true,
          error:
            error && error.message
              ? error.message
              : 'stock_check_failed'
        };

        setState(root, 'error', result);

        return result;
      });

    states.set(root, {
      state: 'checking',
      promise: promise
    });

    return promise;
  }

  function init(root) {
    root = root || document;

    root.querySelectorAll(productSelector).forEach(function (productRoot) {
      if (productRoot.hasAttribute('data-eurolink-stock-bound')) {
        return;
      }

      productRoot.setAttribute(
        'data-eurolink-stock-bound',
        '1'
      );

      if (
        productRoot.getAttribute(
          'data-eurolink-stock-autoload'
        ) === '1'
      ) {
        checkProduct(productRoot);
      }
    });
  }

  function guardProductSubmit(event) {
    var form = event.target;

    if (!form || !form.matches || !form.matches('form')) {
      return;
    }

    var root = getProductRoot(form);

    if (!root) {
      return;
    }

    var current = states.get(root);

    // Dostupan ILI provjera nije uspjela:
    // pusti Shopify normalno.
    if (
      current &&
      (current.state === 'ok' || current.state === 'error')
    ) {
      return;
    }

    // Potvrđeno nedostupan:
    // blokiraj.
    if (current && current.state === 'blocked') {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    // Još nije provjeren.
    event.preventDefault();
    event.stopImmediatePropagation();

    checkProduct(root).then(function (result) {
      // Jedino ovo blokira.
      if (isConfirmedBlocked(result)) {
        return;
      }

      // Sve ostalo, uključujući grešku provjere,
      // dozvoljava Add to cart.
      var addForm = getAddForm(root);

      if (
        !addForm ||
        addForm.hasAttribute('data-eurolink-resubmitting')
      ) {
        return;
      }

      addForm.setAttribute(
        'data-eurolink-resubmitting',
        '1'
      );

      if (typeof addForm.requestSubmit === 'function') {
        addForm.requestSubmit();
      } else {
        var addButton =
          root.querySelector('button[name="add"]');

        if (addButton) {
          addButton.click();
        }
      }

      window.setTimeout(function () {
        addForm.removeAttribute(
          'data-eurolink-resubmitting'
        );
      }, 0);
    });
  }

  function guardDynamicCheckout(event) {
    var target = event.target;

    if (!target || !target.closest) {
      return;
    }

    if (!target.closest('.shopify-payment-button')) {
      return;
    }

    var root = getProductRoot(target);

    if (!root) {
      return;
    }

    var current = states.get(root);

    // Dostupan ili nije moguće provjeriti:
    // dozvoli Buy now.
    if (
      current &&
      (current.state === 'ok' || current.state === 'error')
    ) {
      return;
    }

    // Potvrđeno nedostupan.
    if (current && current.state === 'blocked') {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    var clickedButton =
      target.closest(
        '.shopify-payment-button button, .shopify-payment-button__button'
      ) || target;

    checkProduct(root).then(function (result) {
      if (isConfirmedBlocked(result)) {
        return;
      }

      // Ponovimo klik.
      // Sada je state ok ili error pa guard dozvoljava prolaz.
      if (
        clickedButton &&
        typeof clickedButton.click === 'function'
      ) {
        clickedButton.click();
      }
    });
  }

  function setCheckoutDisabled(disabled, message) {
    document
      .querySelectorAll(checkoutSelector)
      .forEach(function (button) {
        if (
          !button.hasAttribute(
            'data-eurolink-original-disabled'
          )
        ) {
          button.setAttribute(
            'data-eurolink-original-disabled',
            button.disabled ? '1' : '0'
          );
        }

        if (disabled) {
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');

          if (button.tagName === 'A') {
            button.setAttribute(
              'data-eurolink-blocked-link',
              '1'
            );
          }
        } else {
          restoreButton(button);

          button.removeAttribute(
            'data-eurolink-blocked-link'
          );
        }
      });

    var footer =
      document.getElementById('main-cart-footer') ||
      document.querySelector('.cart__footer') ||
      document.querySelector('cart-drawer');

    if (!footer) {
      return;
    }

    var element =
      footer.querySelector(
        '[data-eurolink-cart-stock-status]'
      );

    if (!element) {
      element = document.createElement('div');

      element.className =
        'eurolink-cart-stock-status';

      element.setAttribute(
        'data-eurolink-cart-stock-status',
        ''
      );

      element.setAttribute(
        'role',
        'status'
      );

      footer.insertBefore(
        element,
        footer.firstChild
      );
    }

    element.textContent = message || '';
    element.hidden = !message;
  }

  function checkCart() {
    window.clearTimeout(cartTimer);

    cartTimer = window.setTimeout(function () {
      if (!document.querySelector(checkoutSelector)) {
        return;
      }

      setCheckoutDisabled(
        true,
        'Provjeravamo dostupnost artikala...'
      );

      var cartUrl =
        (window.routes && window.routes.cart_url
          ? window.routes.cart_url
          : '/cart') + '.js';

      fetchWithTimeout(
        cartUrl,
        {
          credentials: 'same-origin',
          cache: 'no-store'
        },
        requestTimeoutMs
      )

        .then(function (response) {
          if (!response.ok) {
            throw new Error(
              'cart_http_' + response.status
            );
          }

          return response.json();
        })

        .then(function (cart) {
          var items =
            Array.isArray(cart.items)
              ? cart.items
              : [];

          return Promise.all(
            items.map(function (item) {
              var url = absoluteEndpoint();

              if (item.product_id) {
                url.searchParams.set(
                  'product_id',
                  item.product_id
                );
              }

              if (item.handle) {
                url.searchParams.set(
                  'handle',
                  item.handle
                );
              }

              return fetchWithTimeout(
                url.toString(),
                {
                  credentials: 'same-origin',
                  cache: 'no-store'
                },
                requestTimeoutMs
              )

                .then(function (response) {
                  if (!response.ok) {
                    return {
                      ok: false,
                      disable_add_to_cart: false,
                      verification_failed: true,
                      error:
                        'stock_check_http_' +
                        response.status
                    };
                  }

                  return response.json();
                })

                .then(function (result) {
                  return (
                    result || {
                      ok: false,
                      disable_add_to_cart: false,
                      verification_failed: true,
                      error:
                        'stock_check_unavailable'
                    }
                  );
                })

                .catch(function (error) {
                  return {
                    ok: false,
                    disable_add_to_cart: false,
                    verification_failed: true,
                    error:
                      error && error.message
                        ? error.message
                        : 'stock_check_unavailable'
                  };
                });
            })
          );
        })

        .then(function (results) {
          var blocked =
            results.some(function (result) {
              return isConfirmedBlocked(result);
            });

          var verificationFailed =
            results.some(function (result) {
              return (
                result &&
                result.verification_failed === true
              );
            });

          // Samo sigurno potvrđen OOS blokira checkout.
          if (blocked) {
            setCheckoutDisabled(
              true,
              'Jedan ili više artikala više nije dostupno. Molimo uklonite ih iz korpe.'
            );
          }

          // Provjera nije uspjela:
          // checkout ostaje dozvoljen.
          else if (verificationFailed) {
            setCheckoutDisabled(
              false,
              'Dostupnost nekih artikala trenutno nije moguće potvrditi. Kupovinu možete nastaviti.'
            );
          }

          // Sve OK.
          else {
            setCheckoutDisabled(
              false,
              ''
            );
          }
        })

        .catch(function () {
          // Ako čak ni cart checker ne radi:
          // FAIL OPEN.
          setCheckoutDisabled(
            false,
            'Dostupnost trenutno nije moguće potvrditi. Kupovinu možete nastaviti.'
          );
        });
    }, 150);
  }

  document.addEventListener(
    'submit',
    guardProductSubmit,
    true
  );

  document.addEventListener(
    'click',
    guardDynamicCheckout,
    true
  );

  document.addEventListener(
    'DOMContentLoaded',
    function () {
      init(document);
      checkCart();
    }
  );

  document.addEventListener(
    'eurolink:crom-stock:init',
    function (event) {
      init(
        event.detail && event.detail.root
          ? event.detail.root
          : document
      );
    }
  );

  document.addEventListener(
    'eurolink:cart:changed',
    checkCart
  );

  document.addEventListener(
    'click',
    function (event) {
      var link =
        event.target &&
        event.target.closest
          ? event.target.closest(
              '[data-eurolink-blocked-link="1"]'
            )
          : null;

      if (link) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  var observer =
    new MutationObserver(function (mutations) {
      var shouldInitProducts = false;
      var shouldCheckCart = false;

      mutations.forEach(function (mutation) {
        Array.from(
          mutation.addedNodes
        ).forEach(function (node) {
          if (
            !node ||
            node.nodeType !== 1
          ) {
            return;
          }

          if (
            (node.matches &&
              node.matches(productSelector)) ||
            (node.querySelector &&
              node.querySelector(productSelector))
          ) {
            shouldInitProducts = true;
          }

          if (
            (
              node.matches &&
              node.matches(
                checkoutSelector +
                  ', cart-items, cart-drawer, #main-cart-footer'
              )
            ) ||
            (
              node.querySelector &&
              node.querySelector(
                checkoutSelector +
                  ', cart-items, cart-drawer, #main-cart-footer'
              )
            )
          ) {
            shouldCheckCart = true;
          }
        });
      });

      if (shouldInitProducts) {
        init(document);
      }

      if (shouldCheckCart) {
        checkCart();
      }
    });

  observer.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );
})();